import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import { BucketTotals } from "helpers/types";

// The pair buckets — the ones whose report entries carry summed daily rows
// and single_info_cards (Bucket 3 returns account-level values instead).
export const PAIR_BUCKET_KEYS = ["1", "2"] as const;
export type PairBucketKey = (typeof PAIR_BUCKET_KEYS)[number];

interface BucketPairToggleProps {
  value: PairBucketKey;
  // The report response's bucket_totals; a bucket absent from it had no
  // successful data and its option is disabled.
  bucketTotals: BucketTotals | undefined;
  onChange: (value: PairBucketKey) => void;
}

/** Switch for which pair bucket's report data to display. */
const BucketPairToggle = ({
  value,
  bucketTotals,
  onChange,
}: BucketPairToggleProps) => (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={value}
    onChange={(_, next) => next && onChange(next)}
  >
    {PAIR_BUCKET_KEYS.map((key) => (
      <ToggleButton key={key} value={key} disabled={!bucketTotals?.[key]}>
        {`Bucket ${key}`}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default BucketPairToggle;
